import React from 'react';
import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from '../../contants/size';
import { Transition } from 'react-transition-group';
import { useBreakpointValue } from '@chakra-ui/react';
import { Box } from '../../components/UI-CHAKRA/Box';
import { useMyCentralStore } from '../../stores/myCentralStore';

interface SideDrawerProps {
  open: boolean;
  children?: React.ReactNode | null;
}

function SideDrawer(props: SideDrawerProps) {
  const drawerWidth = useBreakpointValue({ base: window.innerWidth - 49, sm: 300 });

  const sideBarWidth = useMyCentralStore((state) => state.sideBarWidth);

  const stateStyle = {
    entering: {
      width: drawerWidth,
      overflow: 'hidden',
      transform: 'translateX(0px)',
      backgroundColor: '#fff',
      opacity: 1,
    },
    entered: {
      width: drawerWidth,
      overflow: 'auto',
      transform: 'translateX(0px)',
      backgroundColor: '#fff',
      opacity: 1,
    },
    exiting: {
      width: drawerWidth,
      overflow: 'auto',
      transform: `translateX(${drawerWidth}px`,
      opacity: 0,
    },
    exited: {
      width: drawerWidth,
      overflow: 'hidden',
      transform: `translateX(${drawerWidth}px)`,
      opacity: 0,
    },
  };

  return (
    <Transition in={props.open} timeout={300} onEnter={(node: any) => node.offsetHeight} unmountOnExit mountOnEnter>
      {(state) => (
        <Box
          float={'right'}
          padding={0}
          border={'1px solid #f1f3f5'}
          height={{
            base: `calc(100vh - ${HEADER_HEIGHT_MOBILE})`,
            sm: `calc(100vh - ${HEADER_HEIGHT})`,
          }}
          id={'side-drawer'}
          style={{
            position: 'absolute',
            right: 0,
            transition: `all 0.3s ease`,
            zIndex: 11,
            background: 'transparent',
            height: '100%',
            marginRight: sideBarWidth,

            // @ts-ignore
            ...stateStyle[state],
          }}
        >
          {props.children}
        </Box>
      )}
    </Transition>
  );
}

export default SideDrawer;
